export default __webpack_public_path__ + "static/MOVECO_2-a8ee3208f25f98ec35c1d2abeae9f280.png";